import { IJourneySchema } from "../../../../types/journeyInput.types";

export const pensionReviewJourney: IJourneySchema = {
  journeyId: "pension-review",
  journeyName: "Pension Review",
  description: "Find out exactly what you're paying and what you could be missing.",
  tagLine: "free & no obligation",
  available: true,
  basePriority: 10,
  priorityRules: [
    {
      fact: "hasPensions",
      operator: "notEqual",
      value: true,
      // justification:
      //   "It looks like you have not added a pension, add for review.",
    },
  ],
  tools: [
    {
      toolId: "loa-pension-review",
      completionOrder: 1,
      isRequired: true,
    },
  ],
  justifications: [
    "Fees and charges you might be paying",
    "Whether your pension is invested at the right level of risk for you",
    "If your money is sitting in an outdated or under-performing fund",
    "Whether there may be opportunities for long-term growth"
  ],
};
